import { useWizard } from "react-use-wizard";
import sellSteps from "../sellSteps";
import BaseStep from "../../../../../../shared/wizard/steps/baseStep";
import { IFillDataWizardSell } from "../..";
import Button from "../../../../../../ui/button";
import useDealRequest from "../../../../../../../api/hooks/use-deal-request";
import { getAccessToken } from "../../../../../../../lib/services/localStorage.service";
import { toast } from "react-toastify";
import {
  EDealRequestType,
  EMarketTypes,
} from "../../../../../../../interfaces";
import { useNavigate } from "react-router-dom";
import AuthModal from "../../../../../auth/components/modals/authModal";
import { PATHS } from "../../../../../../shared/constants";
import useOpenModal from "../../../../../../ui/modal/hooks/useOpenModal";
interface IKnowPriceStep_10 {
  data: IFillDataWizardSell;
  isFourStepPrev: boolean;
}

const KnowPriceStep_10 = ({ data, isFourStepPrev }: IKnowPriceStep_10) => {
  const { goToStep } = useWizard();

  const navigate = useNavigate();

  const handlePrevStep = () => {
    if (isFourStepPrev) {
      goToStep(sellSteps.knowPrice.step_6);
    } else {
      goToStep(sellSteps.knowPrice.step_9);
    }
  };

  const {
    data: dataDealRequest,
    error,
    isMutating,
    trigger,
  } = useDealRequest();

  const { offsetY, open, handleChangeModal } = useOpenModal();

  const handleSendData = async () => {
    if (getAccessToken()) {
      try {
        await trigger({
          type: EDealRequestType.Sale,
          data,
          marketType: EMarketTypes.SECONDARY,
        });
        toast.success("Заявка на продажа создана");
        navigate(`/${PATHS.myDeal}`);
      } catch (error: any) {
        if (error?.message === "Unauthorized") {
          handleChangeModal(true);
        }
        toast.error("Ошибка не удалось отправить заявку");
      }
    } else {
      handleChangeModal(true);
    }
  };

  return (
    <div>
      <BaseStep prevStep={handlePrevStep} text="Отправка заявки:">
        <div>
          <Button
            label="Отправить заявку на покупку"
            onClick={handleSendData}
          />
          <AuthModal
            opened={open}
            onClose={() => handleChangeModal(false)}
            offsetY={offsetY}
          />
        </div>
      </BaseStep>
    </div>
  );
};

export default KnowPriceStep_10;
